import { render, staticRenderFns } from "./pass.vue?vue&type=template&id=48b772eb&scoped=true&"
import script from "./pass.vue?vue&type=script&setup=true&lang=js&"
export * from "./pass.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./pass.vue?vue&type=style&index=0&id=48b772eb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.10.2_babel-core@7.0.0-bridge.0_cache-loader@4.1.0_css-loader@3.6.0_lodash@4.17._qkvgvrmvpkafkn37suro37nope/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48b772eb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/web_gys_admin_online_docker/node_modules/.pnpm/vue-hot-reload-api@2.3.4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('48b772eb')) {
      api.createRecord('48b772eb', component.options)
    } else {
      api.reload('48b772eb', component.options)
    }
    module.hot.accept("./pass.vue?vue&type=template&id=48b772eb&scoped=true&", function () {
      api.rerender('48b772eb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/nb/supplyChain/billInvoicing/pass.vue"
export default component.exports